/**
 * Sao chep text vao clipboard. Co fallback cho trinh duyet cu
 * hoac trang khong chay tren HTTPS (luc do navigator.clipboard khong ton tai).
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
   if (!text) return false

   try {
      if (navigator?.clipboard?.writeText) {
         await navigator.clipboard.writeText(text)
         return true
      }

      const el = document.createElement('textarea')
      el.value = text
      el.style.position = 'fixed'
      el.style.opacity = '0'
      document.body.appendChild(el)
      el.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(el)
      return ok
   } catch {
      return false
   }
}

export default copyToClipboard
